import * as React from 'react';
import getConfig from 'next/config';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { EmphaticText, LabelWrapper, LetterImg } from './style.css';
import { track } from '../../helpers';
import TrackingEvents from '../../common/models/TrackingEvents';
import { shouldUseUnbounce } from '../../helpers/helpers';
import { setNewsletterVisibility } from '../../modules/manageModal';
import Store from '../../common/models/Store';

/* Interfaces */
interface NewsletterModalButtonProps {
  countryId: number;
  header?: boolean;
  s3BasePath: string;
  setVisibility: (value: boolean) => void;
}

/* Helpers */
const mapDispatchToProps = (dispatch: Dispatch) => ({
  setVisibility: (value: boolean) => dispatch(setNewsletterVisibility(value))
});

const mapStateToProps = ({
  api: { countryId, s3BasePath },
  modals: {
    internalNewsletter: { visible }
  }
}: Store) => ({
  countryId,
  newsletterModalVisible: visible,
  s3BasePath
});

/* Component */
class NewsletterModalButton extends React.Component<NewsletterModalButtonProps> {
  handleClick = (): void => {
    const { countryId, setVisibility } = this.props;
    if (!shouldUseUnbounce(countryId)) {
      setVisibility(true);
    }
    track(TrackingEvents.newsletterSubscribeSelected());
  };

  render() {
    const { s3BasePath, countryId, header } = this.props;
    const {
      publicRuntimeConfig: { newsletterClickTargetClass }
    } = getConfig();

    return (
      <React.Fragment>
        <LabelWrapper
          className={shouldUseUnbounce(countryId) ? newsletterClickTargetClass : null}
          data-cy="wrapper-newsletter-open-modal"
          header={header}
          onClick={this.handleClick}
        >
          <LetterImg header={header} src={`${s3BasePath}mkt/icon/icon_newsletter.png`} />
          <EmphaticText header={header}>
            subscribe <span>to our newsletter</span>
          </EmphaticText>
        </LabelWrapper>
      </React.Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsletterModalButton);
